import { Button } from '@shared/components/Button';
import { View, ViewProps } from '@shared/components/View';
import { i18n } from '@shared/util/i18n';
import styles from './MenuLoadMore.module.css';

/**
 * Menu.LoadMore
 *
 * The "Load more" button at the foot of a paged menu list. Sits inside the scroller so it scrolls
 * with the rows — pass it as `Menu.Options`' `footer`, or render it after your own rows.
 */

interface MenuLoadMoreProps extends Omit<ViewProps, 'children'> {
  /** Defaults to "Load more". */
  label?: string;
  onClick: () => void;
  /** Spins the button while the next page is fetched. */
  loading?: boolean;
}

export function MenuLoadMore({ label, onClick, loading, className, ...rest }: MenuLoadMoreProps) {
  return (
    <View center className={[styles.menuLoadMore, className]} {...rest}>
      <Button
        variant="tertiary"
        size="medium"
        label={label ?? i18n('common.loadMore')}
        loading={loading}
        onClick={onClick}
      />
    </View>
  );
}
